import { Route, Routes, BrowserRouter as Router, Navigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { Fragment } from "react";
import { Container } from 'react-bootstrap';

import AuthRoute from './authRoute';
import UnAuthRoute from './unAuthRoute';
import ProtectedRoute from './protectedRoute';
import ReferalRoute from './referalRoute';
import OtpRoute from './otpRoute';
import Main from './pages/main';
import Wallet from './pages/wallet';
import ChargeWallet from './pages/wallet/charge';
import Withdraw from './pages/wallet/withdraw';
import NeedLogin from './pages/user/need_login';
import Login from './pages/user/login';
import Verification from './pages/user/verification';
import Referal from './pages/user/referal';
import Profile from './pages/user/profile';
import EditProfile from './pages/user/edit_profile';
import BuyNormalUser from './pages/buy/buy_normal_user';
import BuyOrgUser from './pages/buy/buy_org_user';
import BarcodeGenerate from './pages/buy/barcode_generate';
import Installments from './pages/installments';
import InstallmentsBarcode from './pages/installments/barcode_generate';
import InstallmentsUploadFactor from './pages/installments/upload_factor';
import Shop from './pages/shop';
import Shops from './pages/shops';
import ScrollToTop from './partials/ScrollToTop';
import Footer from './partials/footer/Index';
import BackDrop from './partials/BackDrop';
import Snackbar from './partials/snackbar';
import PayResult from './partials/pay';
import Support from './pages/support';
import SearchBranch from './pages/transfer/searchBranch';
import SelectBranch from './pages/shop/selectBranch';
import SearchBranchInstallments from './pages/installments/searchBranch';
import Transfer from './pages/transfer';
import Rules from './pages/rules';
import Tutorial from './pages/tutorial';


const Root = () => {

    const { token, profile } = useSelector(state => state.user);
    const { phoneNumber } = useSelector(state => state.login);
    const { showReferalPage, temporaryToken } = useSelector(state => state.referal);
    const isCompleteProfile = (profile.fname !== undefined && profile.fname !== '');

    return (
        <div style={{height: "100%"}}>
            <Router>
                <Fragment>
                    <Container id="container-root">
                        <ScrollToTop />
                        <BackDrop />
                        <Snackbar />
                        <Routes> 
                            <Route path='/' element={<Main />} />
                            <Route path='/shop/:shop' element={<Shop />} />
                            <Route path='/shop/:shop/:shopTitle' element={<Shop />} />
                            <Route path='/shops/:title/:cat' element={<Shops />} />
                            <Route path='/pay-result/:origin/:status' element={<PayResult />} />
                            <Route path='/support' element={<Support />} />
                            <Route path='/rules' element={<Rules />} />
                            <Route path='/tutorial' element={<Tutorial />} />

                            <Route path='/transfer' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><Transfer /></ProtectedRoute>} />
                            <Route path='/transfer/search' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><SearchBranch /></ProtectedRoute>} />
                            <Route path='/transfer/branch' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><SelectBranch /></ProtectedRoute>} />
                            <Route path='/wallet' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><Wallet /></ProtectedRoute>} />
                            <Route path='/charge-wallet' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><ChargeWallet /></ProtectedRoute>} />
                            <Route path='/withdraw' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><Withdraw /></ProtectedRoute>} />
                            <Route path='/barcode_generate' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><BarcodeGenerate /></ProtectedRoute>} />
                            <Route path='/buy' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}>{profile.user_org_credit > 0 ? <BuyOrgUser /> : <BuyNormalUser />}</ProtectedRoute>} />
                            <Route path='/installments' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><Installments /></ProtectedRoute>} />
                            <Route path='/installments/search' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><SearchBranchInstallments /></ProtectedRoute>} />
                            <Route path='/installments/barcode' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><InstallmentsBarcode /></ProtectedRoute>} />
                            <Route path='/installments/upload-factor' element={<ProtectedRoute isAuthenticated={!!token} completeProfile={isCompleteProfile} showReferalPage={showReferalPage}><InstallmentsUploadFactor /></ProtectedRoute>} />
                            
                            <Route path='/profile' element={<AuthRoute isAuthenticated={!!token}><Profile /></AuthRoute>} />
                            <Route path='/edit_profile' element={<AuthRoute isAuthenticated={!!token}><EditProfile /></AuthRoute>} />
                            
                            <Route path='/login' element={<UnAuthRoute isAuthenticated={!!token}><Login /></UnAuthRoute>} />
                            <Route path='/auth_err' element={<UnAuthRoute isAuthenticated={!!token}><NeedLogin /></UnAuthRoute>} />
                            
                            <Route path='/verification' element={<OtpRoute isAuthenticated={!!token} showReferalPage={showReferalPage} temporaryToken={temporaryToken} phoneNumber={phoneNumber}><Verification /></OtpRoute>} />
                            <Route path='/referal' element={<ReferalRoute isAuthenticated={!!token} showReferalPage={showReferalPage} temporaryToken={temporaryToken}><Referal /></ReferalRoute>} />

                            
                            

                            <Route path='/beta' />
                            <Route path={"*"} element={ <Navigate replace to={ "/" }/> } />
                        </Routes>

                        <Footer />
                    </Container>
                </Fragment>
            </Router>
        </div>
    );

}

export default Root;
